import Form from 'flarum/common/components/Form';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import fullTime from 'flarum/common/helpers/fullTime';
import humanTime from 'flarum/common/helpers/humanTime';
import username from 'flarum/common/helpers/username';
import extractText from 'flarum/common/utils/extractText';
import ItemList from 'flarum/common/utils/ItemList';
import Stream from 'flarum/common/utils/Stream';
import UserCard from 'flarum/forum/components/UserCard';
import FormModal from 'flarum/common/components/FormModal';
export default class ProcessErasureRequestModal extends FormModal {
  loadingAnonymization = false;
  loadingDeletion = false;
  oninit(vnode) {
    super.oninit(vnode);
    this.request = this.attrs.request;
    this.comments = Stream('');
  }
  className() {
    return 'ProcessErasureRequestModal Modal--medium';
  }
  title() {
    return app.translator.trans('flarum-gdpr.forum.process_erasure.title');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m(Form, {
      className: "Form--centered"
    }, this.fields().toArray()));
  }
  fields() {
    const items = new ItemList();
    const erasureRequest = this.attrs.request;
    items.add('text', m("div", null, m(UserCard, {
      className: "UserCard--popover UserCard--gdpr",
      controlsButtonClassName: "Button",
      user: this.request.user()
    }), m("p", {
      className: "helpText"
    }, app.translator.trans('flarum-gdpr.forum.process_erasure.text', {
      name: username(this.request.user())
    }))));
    const createdAt = erasureRequest.createdAt();
    const userConfirmedAt = erasureRequest.userConfirmedAt();
    items.add('timestamps', m("div", {
      className: "helpText"
    }, createdAt && m("p", null, app.translator.trans('flarum-gdpr.forum.process_erasure.requested_at', {
      date: humanTime(createdAt)
    })), userConfirmedAt && m('[', null, m("p", null, app.translator.trans('flarum-gdpr.forum.process_erasure.confirmed_at', {
      date: humanTime(userConfirmedAt)
    })), m("p", null, app.translator.trans('flarum-gdpr.forum.process_erasure.eligible_at', {
      date: fullTime(new Date(userConfirmedAt.getTime() + 30 * 24 * 60 * 60 * 1000))
    })))), 90);
    erasureRequest?.reason() && items.add('reason', m("p", {
      className: "helpText"
    }, m("code", null, erasureRequest.reason())));
    items.add('comments', m("div", {
      className: "Form-group"
    }, m("textarea", {
      className: "FormControl",
      value: this.comments(),
      bidi: this.comments,
      placeholder: extractText(app.translator.trans('flarum-gdpr.forum.process_erasure.comments_label'))
    })));
    if (app.forum.attribute('erasureAnonymizationAllowed')) {
      items.add('anonymize', m("div", {
        className: "Form-group"
      }, Button.component({
        className: 'Button Button--primary Button--block',
        loading: this.loadingAnonymization,
        onclick: () => this.process('anonymization')
      }, app.translator.trans('flarum-gdpr.forum.process_erasure.anonymization_button'))));
    }
    if (app.forum.attribute('erasureDeletionAllowed')) {
      items.add('delete', m("div", {
        className: "Form-group"
      }, Button.component({
        className: 'Button Button--danger Button--block',
        loading: this.loadingDeletion,
        onclick: () => this.process('deletion')
      }, app.translator.trans('flarum-gdpr.forum.process_erasure.deletion_button'))));
    }
    return items;
  }
  process(mode) {
    if (!confirm(app.translator.trans('flarum-gdpr.forum.process_erasure.confirm', {
      name: extractText(username(this.request.user())),
      mode
    }, true))) {
      return;
    }
    if (mode === 'anonymization') {
      this.loadingAnonymization = true;
    } else {
      this.loadingDeletion = true;
    }
    m.redraw();
    this.request.save({
      processedMode: mode,
      processorComment: this.comments()
    }).then(erasureRequest => {
      app.store.remove(erasureRequest);
      this.loadingAnonymization = false;
      this.loadingDeletion = false;
      m.redraw();
      this.hide();
    }).catch(() => {
      this.loadingAnonymization = false;
      this.loadingDeletion = false;
      m.redraw();
    });
  }
}
flarum.reg.add('flarum-gdpr', 'forum/components/ProcessErasureRequestModal', ProcessErasureRequestModal);